import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import { api, ErroApi, type Usuario } from './api';

interface Sessao {
  usuario: Usuario | null;
  carregando: boolean;
  entrar: (email: string, senha: string) => Promise<void>;
  sair: () => Promise<void>;
  recarregar: () => Promise<void>;
}

const Ctx = createContext<Sessao | null>(null);

export function ProvedorSessao({ children }: { children: ReactNode }) {
  const [usuario, setUsuario] = useState<Usuario | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    api<{ usuario: Usuario }>('/auth/eu')
      .then((r) => setUsuario(r.usuario))
      .catch((e) => { if (!(e instanceof ErroApi && e.status === 401)) console.error(e); })
      .finally(() => setCarregando(false));
  }, []);

  const entrar = useCallback(async (email: string, senha: string) => {
    const r = await api<{ usuario: Usuario }>('/auth/login', { metodo: 'POST', corpo: { email, senha, dispositivo: 'Painel web' } });
    setUsuario(r.usuario);
  }, []);

  const recarregar = useCallback(async () => {
    const r = await api<{ usuario: Usuario }>('/auth/eu');
    setUsuario(r.usuario);
  }, []);

  const sair = useCallback(async () => {
    await api('/auth/logout', { metodo: 'POST' }).catch(() => {});
    setUsuario(null);
  }, []);

  return <Ctx.Provider value={{ usuario, carregando, entrar, sair, recarregar }}>{children}</Ctx.Provider>;
}

export function useSessao() {
  const c = useContext(Ctx);
  if (!c) throw new Error('useSessao fora do ProvedorSessao');
  return c;
}

/** O usuário logado tem a permissão? (o servidor confere de novo em toda chamada — isto só esconde botão) */
export function pode(usuario: Usuario | null | undefined, ...permissoes: string[]) {
  return permissoes.some((p) => usuario?.permissoes?.includes(p));
}

export const NOME_PAPEL: Record<string, string> = {
  admin: 'Administrador', despacho: 'Despacho', tecnico: 'Técnico',
  financeiro: 'Financeiro', comercial: 'Comercial', portal_cliente: 'Portal do cliente',
};
